// extracted by mini-css-extract-plugin
module.exports = {"votesInput":"AddErc1155Asset_votesInput__2s7jy","tokenIdInput":"AddErc1155Asset_tokenIdInput__2jWRT","fullWidth":"AddErc1155Asset_fullWidth__2hk_K"};